module.exports = __webpack_public_path__ + "img/freespin_feature.4fecd94f.png";